import { micromark } from 'micromark';

// We don't need the unified syntax tree here so using micromark is simpler
// and probably faster than unified -> remark -> rehype.
// No need to sanitize the HTML because it is handled by micromark.
export default function markdownToHtml(html: string): string {
  return micromark(html);
}
